import React, { useState, useEffect } from "react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import Pagetitle from "../elements/Pagetitle";
import PortfolioStatic from "../elements/PortfolioStatic";
import axios from "axios";
import { getStrapiURL } from "../../lib/api";


const filters = [
  {
    id: 1,
    text: "All Projects",
  },
  {
    id: 2,
    text: "Web",
  },
  {
    id: 3,
    text: "Mobile",
  }
];

const allData = [
  {
    id: 1,
    title: "KoriPass - Digital Wallet Platform",
    category: "Mobile",
    description: "Fintech mobile app: Electronic wallet with physical payment cards. Secure transactions, real-time balance tracking, and seamless payment integration. Built with React Native, Node.js, and PostgreSQL.",
    image: "images/works/Koripass/KoriPassYcard.png",
    popupLink: ["images/works/Koripass/KP_DESC.png","images/works/Koripass/kplogin.jpeg", "images/works/Koripass/kp1.jpeg", "images/works/Koripass/kp2.jpeg", "images/works/Koripass/kp3.jpeg", "images/works/Koripass/kp4.jpeg", "images/works/Koripass/kp5.jpeg"],
  },
  {
    id: 2,
    title: "KoriSchool - Education Management System",
    category: "Mobile",
    description: "School attendance tracking app with real-time parent notifications. QR code scanning, automated alerts for student check-in/out, and comprehensive reporting. React Native + Firebase.",
    image: "images/works/Korischool/KoriSchoolYcard.svg",
    popupLink: [
      "images/works/Korischool/KS_DESC.png",
      "images/works/Korischool/kslogin.jpeg",
      "images/works/Korischool/ks1.jpeg",
      "images/works/Korischool/ks2.jpeg",
    ],
  },
  {
    id: 3,
    title: "Fegn SEO - Digital Agency Platform",
    category: "Web",
    description: "Modern SEO agency website with service showcasing, project portfolio, and lead generation. Optimized for performance and search rankings. Next.js, TypeScript, Tailwind CSS.",
    image: "images/works/FegnSeo/Fegn.png",
    popupLink: ["images/works/FegnSeo/FS_DESC.png", "images/works/FegnSeo/FegnSEO - Home.png"],
  },
  {
    id: 4,
    title: "Parto AI - AI-Powered Content Platform",
    category: "Web",
    description: "SaaS platform leveraging AI for text summarization, job posting generation, content creation, and code interpretation. OpenAI integration, subscription billing. React, Node.js, MongoDB, Stripe.",
    image: "images/works/PartoAi/Parto.png",
    popupLink: [
      "images/works/PartoAi/PA_DESC.png",
      "images/works/PartoAi/Parto-Login.png",
      "images/works/PartoAi/Parto-Inscription.png",
      "https://www.youtube.com/watch?v=1GtmV1atwow&ab_channel=kasizzizer",
      "https://www.youtube.com/watch?v=Nf8nYJ9lM3Q&ab_channel=kasizzizer",
      "https://www.youtube.com/watch?v=GF35rhNgzF8&ab_channel=kasizzizer",
      "https://www.youtube.com/watch?v=UCwIbsxen7s&ab_channel=kasizzizer"
    ],
  },
  {
    id: 5,
    title: "TexSoro - OCR Note-Taking App",
    category: "Mobile",
    description: "Mobile app with image-to-text extraction using OCR technology. Save, organize, and search extracted text as notes. React Native, Google ML Kit, SQLite.",
    image: "images/works/Texsoro/TexsoroYcard.svg",
    popupLink: [
      "images/works/Texsoro/TS_DESC.png",
      "images/works/Texsoro/texsoroHome.jpeg",
      "images/works/Texsoro/texsoroUpload.jpeg",
      "images/works/Texsoro/texsoroGetext.jpeg",
      "images/works/Texsoro/texsoroEdit.jpeg",
      "images/works/Texsoro/texsoroNotes.jpeg",
    ],
  },
  {
    id: 6,
    title: "Shap - Hospitality Booking Platform",
    category: "Web",
    description: "Full-featured booking platform for hotels, villas, apartments, and event venues. Advanced search, filters, real-time availability, payment integration. React, Node.js, Stripe, AWS.",
    image: "images/works/Shap/Shap.png",
    popupLink: [
      "images/works/Shap/SA_DESC.png",
      "images/works/Shap/shapHome.png",
    ],
  }
];


function Works() {
  // const [projects] = useState(allData);
  const [projects, setProjects] = useState([]);
  // const [dataVisibleCount, setDataVisibleCount] = useState(6);
  // const [dataIncrement] = useState(3);
  // const [activeFilter, setActiveFilter] = useState("");
  // const [visibleItems, setVisibleItems] = useState([]);
  // const [noMorePost, setNoMorePost] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [getAllItems] = useState(allData);
  const [dataVisibleCount, setDataVisibleCount] = useState(6);
  const [dataIncrement] = useState(3);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [noMorePost, setNoMorePost] = useState(false);

  useEffect(() => {
    setActiveFilter(filters[0].text.toLowerCase());
    setVisibleItems(getAllItems.filter((item) => item.id <= 6));
  }, [getAllItems]);

  const handleChange = (e) => {
    e.preventDefault();
    setActiveFilter(e.target.textContent.toLowerCase());
    let tempData;
    if (e.target.textContent.toLowerCase() === filters[0].text.toLowerCase()) {
      tempData = getAllItems.filter((data) => data.id <= dataVisibleCount);
    } else {
      tempData = getAllItems.filter(
        (data) =>
          data.category === e.target.textContent.toLowerCase() &&
          data.id <= dataVisibleCount
      );
    }
    setVisibleItems(tempData);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    let tempCount = dataVisibleCount + dataIncrement;
    if (dataVisibleCount > getAllItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      if (activeFilter === filters[0].text.toLowerCase()) {
        console.log("they are same");
        setVisibleItems(getAllItems.filter((data) => data.id <= tempCount));
      } else {
        setVisibleItems(
          getAllItems.filter(
            (data) => data.category === activeFilter && data.id <= tempCount
          )
        );
      }
    }
  };

  // useEffect(() => {
  //   const fetchProjectsData = async () => {
  //     setLoading(true);
  //     try {
  //       let url = getStrapiURL("/api/projects?populate=*");
  //       const res = await axios.get(url);
  //       console.log("data fetched pj", res.data.data);
  //       setProjects(res.data.data);
  //       setLoading(false);
  //     } catch (error) {
  //       setError(error);
  //       setLoading(false);
  //     }
  //   };
  //   fetchProjectsData();
  // }, []);

  // useEffect(() => {
  //   setActiveFilter(filters[0].text.toLowerCase());
  //   setVisibleItems(projects?.filter((item) => item.id <= 6));
  // }, [projects]);

  // const handleChange = (e) => {
  //   e.preventDefault();
  //   setActiveFilter(e.target.textContent.toLowerCase());
  //   let tempData;
  //   if (e.target.textContent.toLowerCase() === filters[0].text.toLowerCase()) {
  //     tempData = projects.filter((data) => data.id <= dataVisibleCount);
  //   } else {
  //     tempData = projects.filter(
  //       (data) =>
  //         data.category === e.target.textContent.toLowerCase() &&
  //         data.id <= dataVisibleCount
  //     );
  //   }
  //   setVisibleItems(tempData);
  // };

  // const handleLoadmore = (e) => {
  //   e.preventDefault();
  //   let tempCount = dataVisibleCount + dataIncrement;
  //   if (dataVisibleCount > projects.length) {
  //     setNoMorePost(true);
  //   } else {
  //     setDataVisibleCount(tempCount);
  //     if (activeFilter === filters[0].text.toLowerCase()) {
  //       console.log("they are same");
  //       setVisibleItems(projects.filter((data) => data.id <= tempCount));
  //     } else {
  //       setVisibleItems(
  //         projects.filter(
  //           (data) => data.category === activeFilter && data.id <= tempCount
  //         )
  //       );
  //     }
  //   }
  // };

  // return (
  //   <section id="works">
  //     <div className="container">
  //       <Pagetitle title="Projets récents" />
  //       {/* Start Portfolio Filters */}
  //       <AnimationOnScroll
  //          animateIn="animate__fadeInUp"
  //          animateOut="animate__fadeOutDown"
  //          animateOnce={true}
  //       >
  //         <ul className="portfolio-filter list-inline">
  //           {filters.map((filter) => (
  //             <li className="list-inline-item" key={filter.id}>
  //               <button
  //                 onClick={handleChange}
  //                 className={
  //                   filter.text.toLowerCase() === activeFilter
  //                     ? "text-capitalize current"
  //                     : "text-capitalize"
  //                 }
  //               >
  //                 {filter.text}
  //               </button>
  //             </li>
  //           ))}
  //         </ul>
  //       </AnimationOnScroll>
  //       {/* End Portfolio Filters */}

  //       {/* Start Portfolio Items */}
  //       <div className="row portfolio-wrapper">
  //         {/* {visibleItems?.map((item) => (
  //           <div className="col-md-4 col-sm-6 grid-item" key={item?.id}>
  //             <Portfolio portfolioBrut={item?.attributes} />
  //           </div>
  //         ))} */}
  //         {allData?.map((item) => (
  //           <div className="col-md-4 col-sm-6 grid-item" key={item?.id}>
  //             <PortfolioStatic portfolio={item} />
  //           </div>
  //         ))}
  //       </div>
  //       {/* End Portfolio Items */}
  //       <div className="load-more text-center mt-4">
  //         <button
  //           className="btn btn-default"
  //           onClick={handleLoadmore}
  //           disabled={noMorePost ? "disabled" : null}
  //         >
  //           {noMorePost ? (
  //             "No more items"
  //           ) : (
  //             <span>
  //               <i className="fas fa-spinner"></i> Load more
  //             </span>
  //           )}
  //         </button>
  //       </div>
  //     </div>
  //   </section>
  // );

  return (
    <section id="works">
      <div className="container">
        <Pagetitle title="Featured Projects" />
        {/* Start Portfolio Filters */}
        <AnimationOnScroll
          animateIn="fadeInUp"
          animateOut="fadeInOut"
          animateOnce={true}
        >
          <ul className="portfolio-filter list-inline">
            {filters.map((filter) => (
              <li className="list-inline-item" key={filter.id}>
                <button
                  onClick={handleChange}
                  className={
                    filter.text.toLowerCase() === activeFilter
                      ? "text-capitalize current"
                      : "text-capitalize"
                  }
                >
                  {filter.text}
                </button>
              </li>
            ))}
          </ul>
        </AnimationOnScroll>
        {/* End Portfolio Filters */}

        {/* Start Portfolio Items */}
        <div className="row portfolio-wrapper">
          {visibleItems.map((item) => (
            <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
              <PortfolioStatic portfolio={item} />
            </div>
          ))}
        </div>
        {/* End Portfolio Items */}

        <div className="load-more text-center mt-4">
          <button
            className="btn btn-default btn-lg"
            onClick={handleLoadmore}
            disabled={noMorePost ? "disabled" : null}
          >
            {noMorePost ? (
              "All projects loaded"
            ) : (
              <span>
                <i className="fas fa-spinner"></i> Load more projects
              </span>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Works;
